const AppSections = {
	Game: { id: "ADD_PLAYS", gameAccess: ["ADD_PLAYS"] },
	GameStats: { id: "VIEW_STATS", gameAccess: ["VIEW_STATS"] },
	GameConfig: { id: "GAME_CONFIG", gameAccess: ["GAME_CONFIG"] },
	GameFinalize: { id: "FINALIZE", gameAccess: ["FINALIZE"] },
	GameInfo: { id: "EVENT_INFO", gameAccess: ["EVENT_INFO"] },
	Stream: { id: "stream", gameAccess: ["STREAM"] },
	TeamInfo: {
		id: "TEAM_INFO",
		gameAccess: ["HOME_TEAM_INFO", "AWAY_TEAM_INFO"]
	},
	TeamImport: { id: "teamImport", gameAccess: ["ALL"] },
	SeasonSettings: { id: "seasonSettings", gameAccess: ["ALL"] },
	AddPlayer: { id: "addPlayer", gameAccess: ["ALL"] }
};

export default AppSections;
